import { c as _c } from "react/compiler-runtime";
import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { SingleTabEditDialog, SingleTabEditDialogProps } from 'record-it-components/modal/SingleTabEditDialog/SingleTabEditDialog';
import { prepareProps } from 'record-it-components/utils/propUtils';
import { EntityName } from 'record-it-time-common/EntityName';
import { TimeTrackingConfiguration } from '../../../classes/entities/TimeTrackingConfiguration/timeTrackingConfigurationTypes';
import { useModifyEntityCallback } from '../../../hooks/entity/useModifyEntityCallback';
import { EditTimeTrackingConfigurationForm } from '../EditTimeTrackingConfigurationForm/EditTimeTrackingConfigurationForm';
export type EditTimeTrackingConfigurationDialogProps = Omit<SingleTabEditDialogProps, 'tabTitle' | 'children'> & {
  timeTrackingConfiguration: TimeTrackingConfiguration;
};
export const EditTimeTrackingConfigurationDialog: FunctionComponent<EditTimeTrackingConfigurationDialogProps> = React.memo(props => {
  const $ = _c(14);
  let t0;
  if ($[0] !== props) {
    t0 = prepareProps({
      props,
      ignoreChildren: true
    });
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let remainingProps;
  let timeTrackingConfiguration;
  if ($[2] !== t0) {
    ({
      timeTrackingConfiguration,
      ...remainingProps
    } = t0);
    $[2] = t0;
    $[3] = remainingProps;
    $[4] = timeTrackingConfiguration;
  } else {
    remainingProps = $[3];
    timeTrackingConfiguration = $[4];
  }
  const {
    t
  } = useTranslation();
  const handlePropertyChanged = useModifyEntityCallback(EntityName.TimeTrackingConfiguration);
  let t1;
  if ($[5] !== t) {
    t1 = t("components.timeTrackingConfiguration.EditTimeTrackingConfigurationDialog.title");
    $[5] = t;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== handlePropertyChanged || $[8] !== timeTrackingConfiguration) {
    t2 = <EditTimeTrackingConfigurationForm timeTrackingConfiguration={timeTrackingConfiguration} onPropertyChanged={handlePropertyChanged} data-testid="EditTimeTrackingConfigurationDialog.Form" />;
    $[7] = handlePropertyChanged;
    $[8] = timeTrackingConfiguration;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== remainingProps || $[11] !== t1 || $[12] !== t2) {
    t3 = <SingleTabEditDialog {...remainingProps} tabTitle={t1}>{t2}</SingleTabEditDialog>;
    $[10] = remainingProps;
    $[11] = t1;
    $[12] = t2;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  return t3;
});